module.exports = __webpack_public_path__ + "static/media/No_Leads.0b902edb.png";